export const isDefaultLanguage = () => process.env.GATSBY_LANGUAGE === "en-US";

export const isStoryblokPreview = () =>
	process.env.GATSBY_STORYBLOK_STATUS === "draft";
